module.exports = __webpack_public_path__ + "static/cloud-icon-cd988f766add69643ffe071dbf81bf2d.png";